import { useEffect } from "react";
import mapboxgl from "mapbox-gl";

import { SNAP_INDICATOR_LAYER, SNAP_INDICATOR_SOURCE } from "fond/draw/snapIndicator";

export const useSnapIndicator = (map: mapboxgl.Map | undefined): void => {
  useEffect(() => {
    if (!map) return undefined;

    if (!map.getSource(SNAP_INDICATOR_SOURCE)) {
      map.addSource(SNAP_INDICATOR_SOURCE, {
        type: "geojson",
        data: { type: "FeatureCollection", features: [] },
      });
    }

    if (!map.getLayer(SNAP_INDICATOR_LAYER)) {
      map.addLayer({
        id: SNAP_INDICATOR_LAYER,
        type: "circle",
        source: SNAP_INDICATOR_SOURCE,
        paint: {
          "circle-radius": 7,
          "circle-color": "#1489EF",
          "circle-opacity": 0.6,
          "circle-stroke-width": 2,
          "circle-stroke-color": "#1489EF",
        },
      });
    }

    return () => {
      if (map.getLayer(SNAP_INDICATOR_LAYER)) map.removeLayer(SNAP_INDICATOR_LAYER);
      if (map.getSource(SNAP_INDICATOR_SOURCE)) map.removeSource(SNAP_INDICATOR_SOURCE);
    };
  }, [map]);
};
